var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 11,
    fill: "#00CE00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8955 15.9363C10.5651 15.9363 10.2866 15.797 10.0601 15.5186L7.17847 11.929C7.08879 11.8204 7.02507 11.7166 6.9873 11.6174C6.94954 11.5136 6.93066 11.4074 6.93066 11.2988C6.93066 11.0581 7.0109 10.8599 7.17139 10.7041C7.33187 10.5436 7.53719 10.4634 7.78735 10.4634C8.06584 10.4634 8.29948 10.5837 8.48828 10.8245L10.8672 13.8831L15.4692 6.56226C15.5778 6.40177 15.6887 6.28849 15.802 6.22241C15.9153 6.15161 16.0569 6.11621 16.2268 6.11621C16.4722 6.11621 16.6729 6.19409 16.8286 6.34985C16.9891 6.5009 17.0693 6.69678 17.0693 6.9375C17.0693 7.0319 17.0528 7.12866 17.0198 7.22778C16.9915 7.3269 16.9419 7.43075 16.8711 7.53931L11.731 15.4973C11.5327 15.79 11.2542 15.9363 10.8955 15.9363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0918cba39f7fc7a9ac02854fe3037ece.svg";
export { ForwardRef as ReactComponent };